import { useState } from 'react';
import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { NotificationBanners } from '@/components/notifications/NotificationBanners';
import { BillingAlertBanner } from '@/components/notifications/BillingAlertBanner';
import { SetPasswordBanner } from '@/components/notifications/SetPasswordBanner';

export function PortalLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-6">
          {/* Global payment alert — live-derived, clears when resolved */}
          <div className="mb-4 empty:hidden">
            <BillingAlertBanner />
          </div>
          {/* Global broadcast banners — dismissible, server-persisted */}
          <div className="mb-4 empty:hidden">
            <NotificationBanners />
          </div>
          {/* Soft reminder for Shopify-provisioned accounts without a password */}
          <div className="mb-4 empty:hidden">
            <SetPasswordBanner />
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
